import { render, staticRenderFns } from "./CredentialsDetails.vue?vue&type=template&id=abffa8aa&scoped=true&"
import script from "./CredentialsDetails.vue?vue&type=script&lang=js&"
export * from "./CredentialsDetails.vue?vue&type=script&lang=js&"
import style0 from "./CredentialsDetails.vue?vue&type=style&index=0&id=abffa8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abffa8aa",
  null
  
)

export default component.exports